import { ITreeviewLopFocusedValue } from "../../../components-data/treeview-lop/TreeviewLop";
import { IFocusCell } from "../../../components-ui/data-table/DataTable";
import { ILopTuNguyenSelectRequest } from "../../../model/request/lop-tin-chi/ILopTuNguyenSelectRequest";
import { IHeSoLopTuNguyenUpdateOneRequest } from "../../../model/request/thiet-lap/IHeSoLopTuNguyenUpdateOneRequest";
import { IPlanLopTinChiVm } from "../../../model/respone/lop-tin-chi/IPlanLopTinChiVm";
import { IAccHeSoLopTuNguyen } from "../../../model/respone/thiet-lap/IAccHeSoLopTuNguyen";
import { IHeSoLopTuNguyenSyncedResponse } from "../../../model/respone/thiet-lap/IHeSoLopTuNguyenSyncedResponse";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eHeSoLopTuNguyenActionsObj = {
  LOAD_LOP_START: {} as ILopTuNguyenSelectRequest,
  LOAD_LOP_SUCCESS: {} as IPlanLopTinChiVm[],
  LOAD_LOP_ERRR: "",

  SELECTED_ID: [] as number[],
  CHANGE_REQUEST: {} as any,

  SYNC_START: {} as number[],
  SYNC_SUCCESS: {} as IHeSoLopTuNguyenSyncedResponse[],
  SYNC_ERR: {} as string,

  SAVE_HESO_LOP_START: {} as IHeSoLopTuNguyenUpdateOneRequest,
  SAVE_HESO_LOP_SUCCESS: {} as IHeSoLopTuNguyenSyncedResponse,
  SAVE_HESO_LOP_ERR: {} as string,

  CLOSE_PROCESSING_MODAL: undefined,

  SHOW_HESO_MODAL: undefined,
  CLOSE_HESO_MODAL: undefined,
  SHOW_EDIT_MODAL: {} as undefined | IAccHeSoLopTuNguyen,
  CLOSE_EDIT_MODAL: undefined,

  CHANGE_FOCUSED_CELL: {} as IFocusCell,

  LOAD_HESO_START: {} as any,
  LOAD_HESO_SUCCESS: {} as IAccHeSoLopTuNguyen[],
  LOAD_HESO_ERRR: "",

  SAVE_HESO_START: {} as IAccHeSoLopTuNguyen,
  SAVE_HESO_SUCCESS: {} as IAccHeSoLopTuNguyen,
  SAVE_HESO_ERROR: "",

  DELETE_HESO_START: 0,
  DELETE_HESO_SUCCESS: undefined,
  DELETE_HESO_ERROR: "",
};
export const eHeSoLopTuNguyenActionIds = generateActionTypeIds(
  eHeSoLopTuNguyenActionsObj,
  "HE_SO_LOP_TU_NGUYEN"
);
export type IHeSoLopTuNguyenActionTypes = IGenericActionType<
  typeof eHeSoLopTuNguyenActionsObj,
  "HE_SO_LOP_TU_NGUYEN"
>;
